import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api, { handleApi } from "pages/api/api";
import { useAlert } from "pages/context/AlertContext";
import { useAuth } from "pages/context/AuthContext";

import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import Divider from "@mui/material/Divider";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import ClienteDetalheCabecalho from "pages/clientes/ClienteDetalheCabecalho";
import ClienteDetalheConteudo from "pages/clientes/ClienteDetalheConteudo";
import PageHeader from "pages/components/PageHeader";

export default function ClienteDetalhe() {
  const { refcliente } = useParams();

  const { showAlert } = useAlert();
  const { temFuncao, userData } = useAuth();

  const [loading, setLoading] = useState(false);
  const [entidade, setEntidade] = useState(null);

  const [openContactos, setOpenContactos] = useState(false);

  const refVendedorAtual = temFuncao("Comercial") ? (userData?.refvendedor || "").trim() : "";

  useEffect(() => {
    let active = true;

    const carregarEntidade = async () => {
      const refentidade = decodeURIComponent(refcliente || "").trim();

      if (!refentidade) {
        setEntidade(null);
        showAlert("Referência da entidade é obrigatória.", "error");
        return;
      }

      setLoading(true);
      setEntidade(null);

      const [dados, err] = await handleApi(
        api.post("Entidades/SelEntidade", {
          refentidade,
          refvendedor: refVendedorAtual,
          idutilizador: userData?.id || 0,
        })
      );

      if (!active) return;

      setLoading(false);

      if (err) {
        showAlert(err, "error");
        setEntidade(null);
        return;
      }

      if (!dados || typeof dados !== "object") {
        showAlert("Não foi possível carregar os dados da entidade.", "error");
        setEntidade(null);
        return;
      }

      setEntidade(dados);
    };

    carregarEntidade();

    return () => {
      active = false;
    };
  }, [refcliente, refVendedorAtual, showAlert]);

  useEffect(() => {
    const limitar = (texto, max = 40) => {
      const valor = String(texto || "").trim();

      if (valor.length <= max) return valor;

      return `${valor.substring(0, max - 3).trim()}...`;
    };

    if (entidade) {
      const ref = String(entidade.ref || entidade.refentidade || "").trim();

      const nome = limitar(entidade.nome || "", 40);

      document.title = nome ? `${ref} - ${nome}` : ref || "Ficha do Cliente";
    } else {
      const ref = decodeURIComponent(refcliente || "").trim();

      if (ref) {
        document.title = ref;
      }
    }

    return () => {
      document.title = "JF Bebidas";
    };
  }, [entidade, refcliente]);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {/* PROGRESS GLOBAL — sempre aqui, logo após o navbar */}
      {loading && (
        <MDBox py={2} display="flex" alignItems="center" justifyContent="center">
          <CircularProgress />
        </MDBox>
      )}

      <PageHeader />

      <MDBox mt={3} mb={3}>
        {!loading && !entidade ? (
          <Card>
            <MDBox p={3}>
              <MDTypography variant="body2" color="text">
                Não foi possível carregar a ficha do cliente.
              </MDTypography>
            </MDBox>
          </Card>
        ) : null}

        {!loading && entidade ? (
          <Card>
            <ClienteDetalheCabecalho
              entidade={entidade}
              onOpenContactos={() => setOpenContactos(true)}
            />

            <Divider sx={{ m: 0 }} />

            <ClienteDetalheConteudo
              entidade={entidade}
              ativo
              openContactos={openContactos}
              onCloseContactos={() => setOpenContactos(false)}
            />
          </Card>
        ) : null}
      </MDBox>
    </DashboardLayout>
  );
}
